import { render, staticRenderFns } from "./MemberSettings.vue?vue&type=template&id=04454c1c&"
import script from "./MemberSettings.vue?vue&type=script&lang=js&"
export * from "./MemberSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MemberSettings.vue"
export default component.exports